/* A+ Algos fas 1: matcher, simulator, kapitalkoll */
(function(){
  function nf(lang, d){ try { return new Intl.NumberFormat(lang === 'sv' ? 'sv-SE' : 'en-GB', {maximumFractionDigits: d||0, minimumFractionDigits: d||0}); } catch(e){ return {format:function(x){return x.toFixed(d||0);}}; } }
  function sgn(x){ return x > 0 ? '+' : (x < 0 ? '−' : ''); }
  function pct(x, lang, d){ var s = nf(lang, d).format(Math.abs(x)); return sgn(x) + s + (lang === 'sv' ? ' %' : '%'); }
  function kr(x, lang){ return nf(lang, 0).format(Math.round(x)) + ' kr'; }

  document.querySelectorAll('[data-aa-match]').forEach(function(root){
    var outs = root.querySelectorAll('.aa-match__res');
    function show(key){ outs.forEach(function(o){ o.hidden = o.getAttribute('data-res') !== key; }); var t = root.querySelector('[data-res="'+key+'"]'); if (t) t.scrollIntoView({block:'nearest', behavior:'smooth'}); }
    function reset(){ outs.forEach(function(o){ o.hidden = true; }); root.querySelectorAll('[data-step="2"]').forEach(function(f){ f.hidden = true; }); root.querySelectorAll('.aa-opt').forEach(function(b){ b.setAttribute('aria-pressed','false'); }); }
    root.querySelectorAll('[data-q1]').forEach(function(b){ b.setAttribute('aria-pressed','false'); b.addEventListener('click', function(){
      reset(); b.setAttribute('aria-pressed','true'); var v = b.getAttribute('data-q1');
      if (v === 'none') { show('none'); return; }
      var f = root.querySelector('[data-for="'+v+'"]'); if (f) { f.hidden = false; var first = f.querySelector('button'); if (first) first.focus({preventScroll:true}); }
    }); });
    root.querySelectorAll('[data-pick]').forEach(function(b){ b.setAttribute('aria-pressed','false'); b.addEventListener('click', function(){
      b.parentNode.querySelectorAll('.aa-opt').forEach(function(x){ x.setAttribute('aria-pressed','false'); }); b.setAttribute('aria-pressed','true'); show(b.getAttribute('data-pick'));
    }); });
    root.querySelectorAll('[data-reset]').forEach(function(b){ b.addEventListener('click', function(){ reset(); var q = root.querySelector('[data-q1]'); if (q) q.focus(); }); });
  });

  document.querySelectorAll('[data-aa-sim]').forEach(function(root){
    var data; try { data = JSON.parse(root.querySelector('[data-aa-sim-data]').textContent); } catch(e){ return; }
    var lang = root.getAttribute('data-lang') === 'sv' ? 'sv' : 'en';
    var amt = root.querySelector('[data-amount]'), sel = root.querySelector('[data-start]'), rng = root.querySelector('[data-range]');
    function o(k){ return root.querySelector('[data-o="'+k+'"]'); }
    function run(){
      var a = Math.max(0, parseFloat(amt.value) || 0), s = parseInt(sel.value, 10) || 0;
      var v = a, peak = a, dd = 0, worst = 0;
      for (var i = s; i < data.p.length; i++){ var r = data.p[i] / 100; v = v * (1 + r); worst = Math.min(worst, data.p[i]); peak = Math.max(peak, v); dd = Math.min(dd, v / peak - 1); }
      var ret = a ? (v / a - 1) * 100 : 0;
      o('value').textContent = kr(v, lang);
      o('ret').textContent = pct(ret, lang, 0); o('ret').className = ret >= 0 ? 'aa-up' : 'aa-down';
      o('dd').textContent = pct(dd * 100, lang, 1); o('dd').className = 'aa-down';
      o('worst').textContent = pct(worst, lang, 1); o('worst').className = 'aa-down';
    }
    amt.addEventListener('input', run);
    sel.addEventListener('change', function(){ rng.value = sel.value; run(); });
    rng.addEventListener('input', function(){ sel.value = rng.value; run(); });
    run();
  });

  document.querySelectorAll('[data-aa-cc]').forEach(function(root){
    var risk = parseFloat(root.getAttribute('data-risk')), lang = root.getAttribute('data-lang') === 'sv' ? 'sv' : 'en';
    var inp = root.querySelector('input'), out = root.querySelector('.aa-cc__o'), ver = root.querySelector('.aa-cc__v'), need = root.querySelector('.aa-cc__n');
    function run(){
      var c = parseFloat(inp.value) || 0; if (c <= 0) { out.textContent = ''; ver.textContent=''; return; }
      var p = risk / c * 100;
      out.textContent = root.getAttribute('data-out').replace('{kr}', nf(lang,0).format(risk)).replace('{pct}', pct(p, lang, 1).replace('+',''));
      var cls = p <= 2 ? 'g' : (p <= 5 ? 'y' : 'r');
      ver.textContent = root.getAttribute('data-' + cls); ver.className = 'aa-cc__v aa-cc__v--' + cls;
      need.textContent = cls === 'g' ? '' : root.getAttribute('data-need').replace('{kr}', nf(lang,0).format(Math.ceil(risk / 0.02 / 1000) * 1000));
    }
    inp.addEventListener('input', run); run();
  });
})();
